// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__2X3ua","authorise__tooltip":"Tooltip_authorise__tooltip__Qei0F","left":"Tooltip_left__15qzA"};